import { motion } from "framer-motion";

import "./Footer.css";
import PageTransition from "../PageTransition/PageTransition";

function Footer() {
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20,
    },
    visible: {
      opacity: 1,
      y: 0,
    },
  };

  return (
    <PageTransition className={"footer-section"}>
      <motion.footer
        className="footer"
        variants={itemVariants}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.8, delay: 0.9 }}
      >
        <p>© 2026 Ostrovskyi Company. All rights reserved.</p>
      </motion.footer>
    </PageTransition>
  );
}

export default Footer;
